import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil.js";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    data() {
        return {
            printing: {
                busy: false
            },
            extending: {
                busy: false
            }
        }
    },
    computed: {
    },
    methods: {
        async printContract(id) {
            this.printing.busy = true;
            const response = await SingPauseApi.getSingleiterContractById(id);
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Singleiter Vetrag.pdf");
            }
            this.printing.busy = false;
        },
        async printMultipleContracts(ids) {
            this.printing.busy = true;
            const response = await SingPauseApi.getMultipleSingleiterContractByIds(
                this.items.filter(item => item.selected).map(item => item.id)
            );
            if (response.ok) {
                BlobUtil.downloadBlob(response.blob, "Singleiter Verträge.pdf");
            }
            this.printing.busy = false;
        },
        async extendItem(id) {
            this.extending.busy = true;
            const response = await SingPauseApi.extendKlassenEntry(this.id, id);
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Der ausgewählte Datensatz ${id} wurde korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Der ausgewählte Datensatz ${id} wurde nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        },
        async extendMultipleItems(ids) {
            this.extending.busy = true;
            const response = await SingPauseApi.extendMultipleKlassenEntries(this.items.filter(item => item.selected).map(item => item.id));
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Die ausgewählten Datensätze wurden korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Die ausgewählten Datensätze wurden nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        },
    }
};
